import "./LoaderLine.css";

export default function loaderLine() {
  return <div className="loader-line"></div>;
}
